import { HttpClient } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { firstValueFrom } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class MediaUploadApiService {
  private readonly http = inject(HttpClient);

  async upload<TResponse>(url: string, file: File, fieldName = 'photo'): Promise<TResponse> {
    const formData = new FormData();
    formData.append(fieldName, file);
    return firstValueFrom(this.http.post<TResponse>(url, formData));
  }

  async delete<TResponse>(url: string): Promise<TResponse> {
    return firstValueFrom(this.http.delete<TResponse>(url));
  }
}

